import MARKETPLACE_ABI from "../abi/Marketplace.json"
import useContract from "./useContract"

export default function useMarketplaceContract(tokenAddress: string) {
  return useContract(tokenAddress, MARKETPLACE_ABI)
}
